import styled from 'styled-components';

export const OnHoverStoreHeaderStyling = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  display: none;
  position: absolute;
  border-radius: 0 0 16px 16px;
  top: 40px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #fffcf5;
  left: ${(props) => props.leftShift};
`;
export const HomeHeader = styled.div`
  display: flex;
  padding: 10px 60px 0;
  height: 90px;
  background: #fffcf5;
  position: ${(props) =>
    props.location == 'PDP' ||
    props.location == 'cdPage' ||
    props.location == 'category'
      ? 'fixed'
      : 'sticky'};
  width: 100%;
  top: ${(props) =>
    props.showHeader == '-56px' &&
    (props.location == 'PDP' ||
      props.location == 'cdPage' ||
      props.location == 'category')
      ? '-65px'
      : props.store
        ? '32px'
        : '0px'};
  z-index: ${(props) => (props.showPopup ? '1' : '999')};
  @media (min-width: 768px) {
    top: ${(props) =>
      props.showHeader == '-56px' ? '-100px' : props.nostrip ? '0' : '30px'};
    position: fixed;
  }
  align-items: center;
  transition: all 0.3s linear;
  column-gap: 50px;
  justify-content: space-between;

  .logo {
    img {
      width: 80px;
      height: 66px;
    }
  }

  @media (max-width: 768px) {
    justify-content: space-between;
    column-gap: 0;
    padding: 6px 0px;
    height: 65px;
    .logo {
      flex-basis: 22%;
      margin-left: -30%;

      img {
        width: 60px;
        height: 50px;
      }

      order: 1;
    }
  }

  .hamburger {
    display: none;
    @media (max-width: 768px) {
      display: block;
      flex-basis: 22%;
      position: relative;
      img {
        display: flex;
        margin: auto;
        width: 32px;
        height: 32px;
      }
    }
  }
`;

export const ShopButton = styled.div`
  background: #ef4e5e;
  margin-right: 12px;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  width: 100%;
  padding: 8px 12px;
  text-align: center;
  border-radius: 8px;

  &.lowOpacity {
    opacity: 0.4;
  }

  @media (min-width: 768px) {
    margin-right: 0px;
    margin-left: 12px;
    cursor: pointer;
  }
`;
export const BrandContainer = styled.div`
  position: fixed;
  top: 0;
  z-index: ${(props) => (props.showPopup ? '1' : '99')};
  width: 100%;
  border-top: 1px solid #eee;
  background: #fffcf5;
  margin-top: ${(props) => (props.nostrip ? '90px' : '120px')};
  flex-basis: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 30px;

  .headerAnchor {
    font-size: 16px;
    font-weight: 600;
    color: #6e6e6e;
    text-transform: capitalize;
    position: relative;
    transition: all 0.3s linear;
    height: 50px;
    padding: 0 20px;
    display: flex;
    align-items: center;

    &:hover {
      color: #ef4e5e;

      &:before {
        width: 100%;
      }

      ${OnHoverStoreHeaderStyling} {
        display: block;
      }
    }

    &:before {
      content: '';
      width: 0;
      position: absolute;
      left: 0;
      bottom: -2px;
      height: 3px;
      border-radius: 2px;
      background-color: #ef4e5e;
      transition: all 0.3s linear;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const DownloadAppHover = styled.div`
  display: flex;
  gap: 10%;
  width: 800px;
  padding: 20px 30px 20px;
  .leftSection {
    flex-basis: 50%;
    .heading {
      font-size: 26px;
      font-weight: 800;
      color: rgb(0, 0, 0, 0.87);
      padding-bottom: 16px;
    }
    .subHeading {
      opacity: 0.87;
      font-size: 22px;
      font-weight: 600;
      color: #000;
      padding-bottom: 16px;
    }
    .featureList {
      p {
        font-size: 17px;
        font-weight: 500;
        color: rgb(0, 0, 0, 0.7);
      }
    }
  }
  .rightSection {
    flex-basis: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .imageParent {
      min-height: 200px;
      text-align: center;
    }
    .orSeperator {
      position: relative;
      padding: 16px 0;
      width: 90%;
      .orText {
        background-color: #fffcf5;
        text-align: center;
        z-index: 4;
        position: relative;
        width: max-content;
        left: 50%;
        padding: 0 8px;
        transform: translate(-50%, 0%);
        font-size: 14px;
        color: rgb(0, 0, 0, 0.5);
        font-weight: 600;
      }
      .seperator {
        position: absolute;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        width: 100%;
        top: 50%;
      }
    }
    .qrCode {
      width: 60%;
    }
    .installIcons {
      display: flex;
      gap: 16px;
      .appleImage {
        width: 46%;
      }
      img {
        width: 50%;
      }
    }
  }
`;
